const SummaryDeltaPositive = require("./summary-delta-positive");
const SummaryDeltaNegative = require("./summary-delta-negative");
const SummaryDeltaNeutral = require("./summary-delta-neutral");
const Tooltip = require("app/shared/components/Tooltip/tooltip");

const propTypes = {
  value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.element]),
  deltaType: React.PropTypes.oneOf(["negative", "positive", "neutral"]),
  tooltipText: React.PropTypes.string
};

const defaultProps = {
  value: 0,
  deltaType: "neutral",
  tooltipText: ""
};

function SummaryDelta({ value, deltaType, tooltipText }) {
  let deltaComponent;

  switch (deltaType) {
    case "positive":
      deltaComponent = <SummaryDeltaPositive element={value} value={value.props.value} />;
      break;
    case "negative":
      deltaComponent = <SummaryDeltaNegative element={value} value={value.props.value} />;
      break;
    default:
      deltaComponent = <SummaryDeltaNeutral element={value} value={value.props.value} />;
  }

  return (
    <div>
      <Tooltip bottom html title={tooltipText} container="#tooltip-container">
        {deltaComponent}
      </Tooltip>
    </div>
  );
}

SummaryDelta.propTypes = propTypes;

module.exports = SummaryDelta;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Dashboard/SummaryDelta/summary-delta.jsx